/**
 * Advent Reveal Class
 * issue: https://rituals.atlassian.net/browse/DL-15114
 */
'use strict';

const advent = require('./advent');
const adventRevealEl = '.js-reveal';
const adventRevealTriggerEl = '.js-reveal-trigger';

const addEvents = () => {
    $(adventRevealTriggerEl).on('click', onClickRevealButton);
};

const onClickRevealButton = (e) => {
    const $target = $(e.currentTarget).closest(adventRevealEl);

    if ($target.hasClass('reveal')) {
        $target.removeClass('reveal');
        setTimeout(() => {
            $target.removeClass('revealed');
        }, 1000);
    } else {
        $target.addClass('reveal');
        setTimeout(() => {
            $target.toggleClass('revealed');
        }, 1000);
    }

    advent.pushAdventDataLayerDataWithActiveProductImageSlide('reveal contents');
};


/**
 * Tests if the adventReveal element exists on the page
 *
 * @returns {Boolean} result of test
 */
const shouldInit = () => {
    return $(adventRevealTriggerEl).length > 0;
};

const adventReveal = {
    init: () => {
        if (shouldInit()) {
            addEvents();
        }
    }
};

module.exports = adventReveal;
